package flagpack.icons.large

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * French Southern Territories Flag (32x24dp)
 *
 * - ISO Alpha-2: TF
 * - ISO Alpha-3: ATF
 * - ISO Numeric: 260
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Large.FrenchSouthernTerritories: ImageVector by lazy {
    ImageVector.Builder(
        name = "French Southern Territories:TF:ATF:260:Large",
        defaultWidth = 32.dp,
        defaultHeight = 24.dp,
        viewportWidth = 32f,
        viewportHeight = 24f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF2E42A5)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(18.789f, 6.2f)
                horizontalLineTo(22.797f)
                horizontalLineTo(22.829f)
                horizontalLineTo(26.837f)
                lineTo(26.053f, 7.704f)
                horizontalLineTo(23.611f)
                verticalLineTo(8.512f)
                horizontalLineTo(25.483f)
                lineTo(24.721f, 9.911f)
                horizontalLineTo(23.611f)
                verticalLineTo(12.709f)
                lineTo(25.438f, 9.83f)
                lineTo(27.803f, 13.925f)
                horizontalLineTo(26.837f)
                lineTo(26.5f, 13.476f)
                horizontalLineTo(24.359f)
                lineTo(22.854f, 16.257f)
                lineTo(22.855f, 16.411f)
                lineTo(22.813f, 16.334f)
                lineTo(22.771f, 16.411f)
                lineTo(22.772f, 16.257f)
                lineTo(21.267f, 13.476f)
                horizontalLineTo(19.126f)
                lineTo(18.789f, 13.925f)
                horizontalLineTo(17.823f)
                lineTo(20.188f, 9.83f)
                lineTo(22.015f, 12.709f)
                verticalLineTo(7.704f)
                horizontalLineTo(19.573f)
                lineTo(18.789f, 6.2f)
                close()
                moveTo(25.486f, 11.509f)
                lineTo(24.96f, 12.317f)
                horizontalLineTo(25.955f)
                lineTo(25.486f, 11.509f)
                close()
                moveTo(20.14f, 11.509f)
                lineTo(20.666f, 12.317f)
                horizontalLineTo(19.671f)
                lineTo(20.14f, 11.509f)
                close()
                moveTo(16.314f, 10.613f)
                lineTo(17.145f, 10.001f)
                lineTo(17.976f, 10.613f)
                lineTo(17.683f, 9.587f)
                lineTo(18.489f, 8.939f)
                lineTo(17.477f, 8.917f)
                lineTo(17.145f, 7.903f)
                lineTo(16.812f, 8.917f)
                lineTo(15.8f, 8.939f)
                lineTo(16.607f, 9.587f)
                lineTo(16.314f, 10.613f)
                close()
                moveTo(28.455f, 10.001f)
                lineTo(27.624f, 10.613f)
                lineTo(27.918f, 9.587f)
                lineTo(27.111f, 8.939f)
                lineTo(28.123f, 8.917f)
                lineTo(28.455f, 7.903f)
                lineTo(28.788f, 8.917f)
                lineTo(29.8f, 8.939f)
                lineTo(28.993f, 9.587f)
                lineTo(29.286f, 10.613f)
                lineTo(28.455f, 10.001f)
                close()
                moveTo(25.08f, 17.803f)
                lineTo(25.91f, 17.191f)
                lineTo(26.742f, 17.803f)
                lineTo(26.448f, 16.777f)
                lineTo(27.255f, 16.129f)
                lineTo(26.243f, 16.107f)
                lineTo(25.91f, 15.094f)
                lineTo(25.578f, 16.107f)
                lineTo(24.566f, 16.129f)
                lineTo(25.373f, 16.777f)
                lineTo(25.08f, 17.803f)
                close()
                moveTo(19.69f, 17.191f)
                lineTo(18.859f, 17.803f)
                lineTo(19.152f, 16.777f)
                lineTo(18.345f, 16.129f)
                lineTo(19.357f, 16.107f)
                lineTo(19.69f, 15.094f)
                lineTo(20.022f, 16.107f)
                lineTo(21.034f, 16.129f)
                lineTo(20.228f, 16.777f)
                lineTo(20.521f, 17.803f)
                lineTo(19.69f, 17.191f)
                close()
                moveTo(21.969f, 20.2f)
                lineTo(22.8f, 19.587f)
                lineTo(23.631f, 20.2f)
                lineTo(23.338f, 19.173f)
                lineTo(24.145f, 18.525f)
                lineTo(23.132f, 18.503f)
                lineTo(22.8f, 17.49f)
                lineTo(22.468f, 18.503f)
                lineTo(21.455f, 18.525f)
                lineTo(22.262f, 19.173f)
                lineTo(21.969f, 20.2f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF50100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8f, 0f)
                horizontalLineTo(12f)
                verticalLineTo(10f)
                horizontalLineTo(8f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF2E42A5)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                horizontalLineTo(4f)
                verticalLineTo(10f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(4f, 0f)
                horizontalLineTo(8f)
                verticalLineTo(10f)
                horizontalLineTo(4f)
                verticalLineTo(0f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun FrenchSouthernTerritoriesPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Large.FrenchSouthernTerritories,
            contentDescription = "French Southern Territories Flag"
        )
    }
}
